<template>
    <div
        class="tooltip is-tooltip-bottom"
        :data-tooltip="tooltip"
    >
        <span
            class="fa fa-cubes icon"
            :class="statusClass"
        ></span>
    </div>
</template>

<script>
import StatusUtil from '../../util/StatusUtil';
export default {
    name : "Allocated",
    props : {
        status : {
            type : Number,
            required : true,
        }
    },
    computed : {
        statusClass () {
            return `status-color-${this.status}`;
        },
        tooltip () {
            const status = StatusUtil.ALLOCATION.findById(this.status);
            return status ? status.name : 'Unknown';
        }
    }
}
</script>

<style scoped>

</style>
